export default "__VITE_ASSET__AiGb6NdW__"